var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Value"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Value",
    clipPath: "url(#clip-Value)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12206",
    "data-name": "Group 12206",
    transform: "translate(-1034.243 48.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(1056 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12995",
    "data-name": "Path 12995",
    d: "M1126.792,469.238,1108.6,491.759l-18.189-22.531c2.8-2.6,5.51-5.161,8.286-7.646a2.681,2.681,0,0,1,1.654-.439q8.219-.047,16.438,0a2.937,2.937,0,0,1,1.809.515C1121.336,464.1,1123.995,466.633,1126.792,469.238Zm-18.44,14.852.446-.018,3.6-13.405h-7.668Zm3.12-.386.3.163,10.711-13.3c-2.438,0-4.365-.051-6.287.036-.472.022-1.23.4-1.337.773C1113.67,475.47,1112.584,479.592,1111.471,483.7Zm-6.144.021.3-.138c-1.081-3.992-2.142-7.99-3.272-11.968-.116-.406-.628-.978-.979-.994-2.073-.094-4.151-.046-6.665-.046Zm-9.563-15.764c6.148.563,8.245-.38,9.621-4.125C1101.157,462.545,1098.248,464.564,1095.764,467.961Zm25.914.117c-3.946-4.415-5.708-5.155-9.619-4.148.766,1.18,1.47,2.348,2.27,3.448a1.71,1.71,0,0,0,1.131.67C1117.412,468.115,1119.366,468.079,1121.679,468.079Zm-9.982-.1-2.707-4.141-3.338,4.141Z",
    transform: "translate(-1090.415 -450.162)",
    fill: "#F6911E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12996",
    "data-name": "Path 12996",
    d: "M1137.546,436.86a4.94,4.94,0,0,0-5.924.092c1.144-2.013,1.617-3.946-.487-6.138a15.226,15.226,0,0,0,3.454.979,12.419,12.419,0,0,0,3.118-.892C1136.373,432.923,1136.078,434.858,1137.546,436.86Z",
    transform: "translate(-1116.412 -430.814)",
    fill: "#F6911E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12997",
    "data-name": "Path 12997",
    d: "M1180.511,439.261a4.865,4.865,0,0,0,.089,6.007c-2.035-1.166-3.988-1.424-6.063.057,1.262-2.042,1.507-3.983-.01-6.054A5.27,5.27,0,0,0,1180.511,439.261Z",
    transform: "translate(-1144.114 -436.207)",
    fill: "#F6911E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12998",
    "data-name": "Path 12998",
    d: "M1098.7,446.163a5.013,5.013,0,0,0-6,.057c1.283-2.052,1.5-3.987-.057-6.048,2.051,1.122,4,1.373,6.076-.067C1097.422,442.179,1097.229,444.111,1098.7,446.163Z",
    transform: "translate(-1091.839 -436.746)",
    fill: "#F6911E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue1);
export default __webpack_public_path__ + "static/media/value-1.340e5f5fe31eca92807dd00ccdf7550e.svg";
export { ForwardRef as ReactComponent };